<template>
  <div class="privacy">
    <privacy-paragraphs/>
    <div class="mm-prv-agree-submit-container clearfix">
      <button
        ref="wdgSubmitButton"
        @click.prevent="onSave"
        class="mm-prv-agree-submit"
        :class="btnClasses"
        :disabled="buttonDisabled"
        :type="buttonType"
        v-if="isButton"
        v-html="submitCaption"
        v-bind="commonAttributes"
      >
      </button>
      <input
        ref="wdgSubmitButton"
        v-if="!isButton"
        @click.prevent="onSave"
        :type="buttonType"
        class="mm-prv-agree-submit"
        :class="btnClasses"
        :disabled="buttonDisabled"
        v-bind="commonAttributes"
        :value="submitCaption"
      >
    </div>

  </div>
</template>

<script>
import PrivacyParagraphs from './PrivacyParagraphs'
import PrivacyFlags from './PrivacyFlags'
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex'
import serialize from 'form-serialize'
import rx from 'rx-lite-dom'
import _isObject from 'lodash/isObject'

export default {
  components: {PrivacyParagraphs, PrivacyFlags},
  data () {
    return {
      commonAttributes: {},
      fldName: null,
      formData: {},
      formPublicData: {},
      otherFormsData: [],
      submitBtnDisabled: false,
      btnClasses: '',
      isButton: false,
      buttonType: 'submit',
      greaterThan600: window.innerWidth > 600,
      dataset: null
    }
  },
  computed: {
    ...mapState(['submitCaption', 'submitClass', 'id', 'submitAttributes']),
    ...mapGetters(['allScrolled', 'privacyIsValid', 'allFlags']),
    buttonDisabled () {
      if (this.submitBtnDisabled) {
        return true
      }
      return !this.privacyIsValid
    }
  },
  mounted () {
    if (this.dataset) {
      for (let key in this.dataset) {
        this.$refs.wdgSubmitButton.dataset[key] = this.dataset[key]
      }
    }
  },
  created () {
    const submit = this.submit()
    submit.style.display = 'none'

    this.addReactivity()
    this.btnClasses = this.submitClass

    this.isButton = (submit.tagName.toLowerCase() === 'button')
    if (!this.isButton) {
      if (submit.type && submit.type !== 'submit') {
        this.buttonType = submit.type
      }
    }

    for (let i = 0; i < this.submitAttributes.length; i++) {
      let currentAttribute = this.submitAttributes[i]
      if (currentAttribute === 'data' || currentAttribute === 'dataset') {
        this.dataset = submit['dataset']
        continue
      }
      if (submit[currentAttribute]) {
        this.commonAttributes[currentAttribute] = submit[currentAttribute]
      }
      if (currentAttribute === 'value' && this.submitCaption) {
        this.$store.commit('setSubmitCaption', this.commonAttributes[currentAttribute])
      }
    }

    for (let i = 0; i < submit.classList.length; i++) {
      let cl = submit.classList[i]
      if (cl !== 'mm-prv-form-submit') {
        this.btnClasses += ' ' + cl
      }
    }
    // console.log('----- gr 600 ', this.greaterThan600)
    // this.serializeForm()

    // console.dir(submit)
    const id = this.$cookie.get('mm-prv-ref')
    if (id) {
      this.setId(id)
      // this.$cookie.delete('mm-prv-ref')
    }
    const privacyRef = this.privacyref()
    privacyRef.value = this.id
  },
  methods: {
    ...mapMutations(['setId']),
    ...mapActions(['save']),
    addReactivity () {
      // console.log(rx)
      // subscribe the form
      const sbb = this.submit()
      this.submitBtnDisabled = sbb.disabled
      rx.DOM.fromEvent(this.form(), 'keyup').debounce(400)
      rx.DOM.fromMutationObserver(sbb, {attributes: true, attributeFilter: ['disabled']})
        .subscribe(o => {
          try {
            this.submitBtnDisabled = o[0].target.disabled
          } catch (e) {
          }
        })
    },
    getRecord () {
      return {
        name: this.name().value || '',
        surname: this.surname().value || '',
        email: this.email().value || '',
        telephone: this.telephone().value || ''
      }
    },
    onSave () {
      this.serializeForm()
      const record = this.getRecord()

      if (window.validateFormMmPrivacy) {
        const formIsValid = window.validateFormMmPrivacy()
        if (!formIsValid) {
          console.log('---- form not valid')
          return
        }
      }

      this.$cookie.set('mm-prv-ref', this.id, {expires: '30s'})
      this.save({
        cryptedForm: this.formData,
        form: this.formPublicData,
        record
      })
        .then(r => {
          if (window && window.privacySubmitClick) {
            window.privacySubmitClick()
          } else {
            const submit = this.submit()
            const form = this.form()
            if (form.onsubmit) {
              if (!form.onsubmit(form)) {
                return
              }
            }
            if (submit.onclick) {
              submit.onclick(form)
            } else if (submit !== undefined && submit.type === 'submit') {
              submit.click()
            } else if (form !== undefined) {
              form.submit()
            }
          }
        })
        .catch(() => {
          if (window && window.privacySubmitClick) {
            window.privacySubmitClick()
          } else {
            const submit = this.submit()
            const form = this.form()
            if (form.onsubmit) {
              if (!form.onsubmit(form)) {
                return
              }
            }
            if (submit.onclick) {
              submit.onclick(form)
            } else if (submit !== undefined && submit.type === 'submit') {
              submit.click()
            } else if (form !== undefined) {
              form.submit()
            }
          }
        })
    },
    getOneByClass (clazz) {
      let elements = document.getElementsByClassName(clazz)
      if (elements && elements.length && elements.length > 0) {
        return elements[0]
      }
      return {}
    },
    getByClass (clazz, defaultValue = []) {
      let elements = document.getElementsByClassName(clazz)
      if (elements && elements.length && elements.length > 0) {
        return elements
      }
      return defaultValue
    },
    serializeForm () {
      this.formData = serialize(this.form(), {hash: true})
      const otherFormsData = this.otherForms()

      if (otherFormsData) {
        for (let i = 0; i < otherFormsData.length; i++) {
          const formData = serialize(otherFormsData[i], {hash: true})
          this.otherFormsData.push(formData)
        }
      }
      const encrypted = this.encrypted()
      let encryptedFields = {}

      for (let i = 0; i < encrypted.length; i++) {
        encryptedFields[encrypted[i].name] = true
      }

      for (let key in this.formData) {
        if (_isObject(this.formData[key])) {
          for (let subKey in this.formData[key]) {
            let srcKey = `${key}[${subKey}]`
            // console.log('key', key, 'subKey', subKey, srcKey, encryptedFields[ subKey ])
            if (!encryptedFields[srcKey]) {
              this.formPublicData[srcKey] = this.formData[key][subKey]
            }
          }
        } else {
          if (!encryptedFields[key]) {
            this.formPublicData[key] = this.formData[key]
          }
        }
      }

      if (otherFormsData) {
        this.formData['_otherforms_'] = this.otherFormsData
      }
    },
    otherForms () {
      return this.getByClass('mm-prv-other-form', null)
    },
    form () {
      return this.getOneByClass('mm-prv-form')
    },
    name () {
      return this.getOneByClass('mm-prv-name')
    },
    surname () {
      return this.getOneByClass('mm-prv-surname')
    },
    telephone () {
      return this.getOneByClass('mm-prv-telephone')
    },
    email () {
      return this.getOneByClass('mm-prv-email')
    },
    submit () {
      return this.getOneByClass('mm-prv-form-submit')
    },
    privacyref () {
      let el = document.getElementById('mm-prv-ref')

      if (!el) {
        const form = this.form()
        el = document.createElement('input')
        el.type = 'hidden'
        el.name = 'mm-prv-ref'
        el.id = 'mm-prv-ref'
        form.appendChild(el)
      }
      return el
    },
    encrypted () {
      return this.getByClass('mm-prv-crp')
    }
  }
}
</script>
<style lang="scss">
.mm-prv-agree-submit-container {
  text-align: left;
  margin-top: 10px;

}

</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue